import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["edge", "flowId", "isMulti", "showEdgeTooltips"];
import styled from 'styled-components';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { ConnectedAddButton } from 'automation-ui-canvas/components/canvas/ConnectorAuxiliary';
import { jsx as _jsx } from "react/jsx-runtime";
const AddButtonWrapper = styled.div.withConfig({
  displayName: "ConnectorButton__AddButtonWrapper",
  componentId: "mu6y8f-0"
})(["background-color:", ";border:", " solid ", ";outline:", " solid ", "!important;border-radius:", ";width:32px;height:32px;display:flex;align-items:center;justify-content:center;cursor:pointer;&:hover{background-color:", ";}"], ({
  theme
}) => theme.color['fill-tertiary-pressed'], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.color['fill-accent-neutral-default'], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.color['fill-accent-neutral-default'], ({
  theme
}) => theme.borderRadius['300'], ({
  theme
}) => theme.color['fill-surface-default']);
const ConnectorButton = _ref => {
  let {
      edge,
      flowId,
      isMulti,
      showEdgeTooltips
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!edge.getShouldShowAddControl()) {
    return null;
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(AddButtonWrapper, {
      children: /*#__PURE__*/_jsx(IconButton, Object.assign({}, buttonProps, {
        use: "unstyled",
        children: /*#__PURE__*/_jsx(ConnectedAddButton, {
          edgeId: edge.getId(),
          isMulti: isMulti,
          flowId: flowId,
          showEdgeTooltips: showEdgeTooltips
        })
      }))
    })
  );
};
export default ConnectorButton;